import axios from 'axios';

// Default to same-origin API when REACT_APP_BACKEND_URL isn't configured
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
export const API = `${BACKEND_URL}/api`;

const withAuthHeaders = (token, config = {}) => {
  const headers = { ...(config.headers || {}) };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return {
    ...config,
    headers
  };
};

export const api = {
  get: async (endpoint, token, config = {}) => {
    const response = await axios.get(`${API}${endpoint}`, withAuthHeaders(token, config));
    return response.data;
  },
  post: async (endpoint, data, token, config = {}) => {
    const response = await axios.post(`${API}${endpoint}`, data, withAuthHeaders(token, config));
    return response.data;
  },
  put: async (endpoint, data, token, config = {}) => {
    const response = await axios.put(`${API}${endpoint}`, data, withAuthHeaders(token, config));
    return response.data;
  },
  patch: async (endpoint, data, token, config = {}) => {
    const response = await axios.patch(`${API}${endpoint}`, data, withAuthHeaders(token, config));
    return response.data;
  }
};
